module.exports = __webpack_public_path__ + "img/no-pic-commercial.1ea6c78b.png";